/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_OverviewInputs */

const cs_property_tab_overview = /** @type {(inputs: Property_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled`)
};

const en_property_tab_overview = /** @type {(inputs: Property_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Property_Tab_OverviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_overview = /** @type {((inputs?: Property_Tab_OverviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_OverviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_overview(inputs)
	return cs_property_tab_overview(inputs)
});